import { Window } from "@progress/kendo-react-dialogs";
import {
  fieldFocusIndex,
  selectedFieldPropertyValues,
  selectedSectionName,
  showColumnsConstructorWindow,
  templateData,
} from "../../Template/NewTemplateSignals";
import ColumnsConstructor from "./ColumnsConstructor";
import { columnsConstructorSessionData, selectedColumnId } from "./ColumnsConstructorSignals";

export const ColumnsConstructorWindow = () => {
  const handlePropertyChange = ({ propName, propValue }) => {
    if (fieldFocusIndex.value === null) {
      templateData.value = {
        ...templateData.value,
        sections: templateData.value.sections.map((section) => {
          if (section.sectionName === selectedSectionName.value) {
            return {
              ...section,
              properties: {
                ...section.properties,
                [propName]: propValue,
              },
            };
          }
          return section;
        }),
      };
    } else {
      templateData.value = {
        ...templateData.value,
        sections: templateData.value.sections.map((section) => {
          if (section.sectionName === selectedSectionName.value) {
            return {
              ...section,
              fields: section.fields.map((field) => {
                if (field.fieldName === selectedColumnId.value) {
                  return {
                    ...field,
                    properties: {
                      ...field.properties,
                      [propName]: propValue,
                    },
                  };
                }
                return field;
              }),
            };
          }
          return section;
        }),
      };
    }
  };

  return (
    <>
      {showColumnsConstructorWindow.value && (
        <Window
          key="field-constructor-window"
          onClose={() => {
            showColumnsConstructorWindow.value = !showColumnsConstructorWindow.value;
            columnsConstructorSessionData.value = [];
          }}
          title={"Columns Constructor"}
          width={1200}
          height={800}
        >
          <ColumnsConstructor
            handlePropertyChange={handlePropertyChange}
            columns={
              selectedFieldPropertyValues.value?.Columns || [
                {
                  id: 0,
                  columnName: "",
                  columnType: "",
                },
              ]
            }
            currentPropertyValues={selectedFieldPropertyValues.value}
          />
        </Window>
      )}
    </>
  );
};
